<template>
  <ul class="social-list">
    <li v-for="(item,index) in dataObj" :key="index">
      <a :href="item.link" target="_blank">
        <img :src="item.iconUrl" alt="">
      </a>
    </li>
  </ul>
</template>

<script>

import {WOW} from 'wowjs'
export default {
  name: 'social-list',
  data(){
    return {
      dataObj: [
        {iconUrl: '/static/svg/facebook.svg', link: 'https://www.facebook.com/meShareIoT/'},
        {iconUrl: '/static/svg/youtube.svg', link: 'http://youtube.com/mesharecloud/'},
        {iconUrl: '/static/svg/instagram.svg', link: 'https://www.instagram.com/meshareiot/'},
        {iconUrl: '/static/svg/linkedin.svg', link: 'https://www.linkedin.com/company/meshare-inc/'},
        {iconUrl: '/static/svg/twitter.svg', link: 'https://twitter.com/meShareIoT'},
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/common.scss';
.social-list{
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  max-width: 220px;
  margin-left: -10px;
  margin-top: 60px;
  @media screen and (max-width: $media-max-width) {
    max-width: unset;
    margin-top: 30px;
  }
  li{
    font-size: 13px;
    color: #000000;
    font-family: 'GothamLight';
    margin: 0px 10px 0 0;
    @media screen and (max-width: $media-max-width) {
      margin: 0px 8px;
    }
    a{
      color: #000000;
      text-decoration: none;
    }
    &:hover{
      @media screen and (min-width: $media-max-width) {
        a{
          color: #ba0c2f;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/footer/social-list.vue